import { useWorkspaceContext } from '../context/workspace.context';

export const useWorkspace = () => {
  return useWorkspaceContext();
};
